import { clock } from "@/lib/voiceSongsApi";

const isOn = (settings, s) => settings.sections[s.id] ?? s.chorus;

/** Where the singers come in — choruses by default; switch any section on or off. */
export default function SectionsPanel({ doc, settings, change }) {
  const sections = doc.sections || [];
  const setAll = (fn) => change((st) => ({ ...st, sections: Object.fromEntries(sections.map((s) => [s.id, fn(s)])) }));
  const toggle = (s) => change((st) => ({ ...st, sections: { ...st.sections, [s.id]: !isOn(st, s) } }));
  const hasChorus = sections.some((s) => s.chorus);
  return (
    <section data-testid="bgv-sections" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-display text-base font-semibold md:text-lg">Where they sing</h2>
        <div className="flex gap-2">
          {hasChorus ? <button type="button" data-testid="bgv-sections-choruses" onClick={() => setAll((s) => s.chorus)} className="rounded-full border border-white/12 px-3 py-1 text-[12px] text-white/75 hover:bg-white/10">Choruses only</button> : null}
          <button type="button" data-testid="bgv-sections-all" onClick={() => setAll(() => true)} className="rounded-full border border-white/12 px-3 py-1 text-[12px] text-white/75 hover:bg-white/10">Everywhere</button>
        </div>
      </div>
      <p data-testid="bgv-sections-from" className="mt-1 text-[12px] text-white/45">
        {doc.info?.sections_from === "lyrics" ? "Found by listening for your lyrics." : "Found from where you sing — add lyrics with [Chorus] tags to target the choruses."}
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        {sections.map((s) => {
          const on = isOn(settings, s);
          return (
            <button key={s.id} type="button" data-testid={`bgv-section-${s.id}`} aria-pressed={on} onClick={() => toggle(s)}
              className={`rounded-2xl border px-3.5 py-2 text-left transition-colors duration-150 ${on ? "border-violet-300/50 bg-violet-400/15 text-white" : "border-white/10 text-white/50 hover:text-white"}`}>
              <span className="block text-[13px] font-medium">{s.label}{s.chorus ? " ★" : ""}</span>
              <span className="block font-mono text-[10px] text-white/45">{clock(s.start)}–{clock(s.end)}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
